module.exports = __webpack_public_path__ + "static/media/Analizci.310f8f05.png";